export default {"src":"__ASTRO_ASSET_IMAGE__VRAku6fjghkApIISiBWPzg__","width":896,"height":1852,"format":"webp"}